<template>
  <div class="main">
    <div style="height:10px"></div>
    <div class="mainTop">
      <div class="topLocation">
        <div class="topLocationImg"><img src="../assets/locationBlue.png" alt=""></div>
        <div class="topLocationTil">{{address}}</div>
      </div>
    </div>
    <div v-if="canteenDetil&&canteenDetil.cEntity">
    <!-- <div class="swiperBox" v-if="canteenDetil&&canteenDetil.cEntity&&canteenDetil.cEntity.cByPicture&&canteenDetil.cEntity.cByPicture.length>0">
      <van-swipe :autoplay="3000" height="150">
        <van-swipe-item v-for="(image, index) in canteenDetil.cEntity.cByPicture" :key="index">
          <img :src="imgUrl+image" :onerror="defaultImg" />
        </van-swipe-item>
      </van-swipe>
    </div> -->
    <div class="canteenDetail">
      <div class="infoTop">
        <div class="infoTf">
          <div class="cantTil">{{canteenDetil.cEntity.cCanteenName}}</div>
          <div class="rightCenterLeft">
            <div class="starList">
              <div class="starBox">
                <img v-for="(item,index) in 5" :key="index" :src="index<parseInt(canteenDetil.cEntity.avgEvaluate)?require('../assets/star.png'):require('../assets/star_active.png')" alt="">
              </div>
            </div>
            <div class="score">{{parseInt(canteenDetil.cEntity.avgEvaluate)}}分</div>
          </div>
        </div>
        <div class="infoTr">
          <div class="collectionIcon" v-if="canteenDetil.cEntity.whetherCollection" @click="collection1"><img src="../assets/collection_active.png" alt=""></div>
          <div class="collectionIcon" v-if="!canteenDetil.cEntity.whetherCollection" @click="collection"><img src="../assets/collection.png" alt=""></div>
          <div class="collectionText" style="color:#EA6363 !important;" v-if="canteenDetil.cEntity.whetherCollection">已收藏</div>
          <div class="collectionText" v-if="!canteenDetil.cEntity.whetherCollection">收藏</div>
        </div>
      </div>
      <div class="bomLine">
        <div class="bomLineLeft">联系电话：</div>
        <div class="bomLineRight" @click="getCall(canteenDetil.cEntity.cPhone)" style="color:#3B87F5">{{canteenDetil.cEntity.cPhone||'暂无'}}</div>
        <div class="bomLineRight" @click="getCall(canteenDetil.cEntity.cLandlineNumber)" style="color:#3B87F5">{{canteenDetil.cEntity.cLandlineNumber||''}}</div>
      </div>
      <div class="bomLine">
        <div class="bomLineLeft">单位地址：</div>
        <div class="bomLineRight" style="color:#3B87F5" @click="changeToNav(canteenDetil.cEntity.cLatitude,canteenDetil.cEntity.cLongitude,canteenDetil.cEntity.cDetailedAddress)">{{canteenDetil.cEntity.cDetailedAddress||'未知地址'}}</div>
      </div>
      <div class="bomLine">
        <div class="bomLineLeft">营业时间：</div>
        <div class="bomLineRight">{{canteenDetil.cEntity.cStartTime}}-{{canteenDetil.cEntity.cEndTime}}</div>
      </div>
      <div class="bomLine">
        <div class="bomLineLeft">供应餐次：</div>
        <div class="bomLineRight">{{canteenDetil.cEntity.cSupplyMealTime||'暂无'}}</div>
      </div>
      <div class="textBox">
        <div class="text">{{canteenDetil.cEntity.cIntroductionCanteen}}</div>
      </div>
    </div>
    </div>
    <div style="height:10px"></div>
    <div class="bomCont" v-if="canteenDetil&&canteenDetil.eList&&canteenDetil.eList.length>0">
      <div class="bomContTil">食堂评价</div>
      <div class="commentList">
        <ul>
          <li v-for="(item,index) in canteenDetil.eList" :key="index">
            <div class="itemTop">
              <div class="itemTopLeft">
                <!-- <div class="itemTopLeftL">
                  <img src="https://img01.yzcdn.cn/vant/apple-1.jpg" alt="">
                </div> -->
                <div class="itemTopLeftR">
                  <div class="itemTopLeftRtop">{{item.wName}}</div>
                  <div class="itemTopLeftRbom">
                    <div class="starList">
                      <div class="starBox" v-for="(itemsss,index) in 5" :key="index">
                        <img :src="index<item.eScore?require('../assets/star.png'):require('../assets/star_active.png')" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="itemTopRight">{{item.adddate}}</div>
            </div>
            <div class="itemText">{{item.eContent}}</div>
            <div class="itemBom" v-if="item.imgList&&item.imgList.length>0">
              <div class="imglist">
                <div class="imgItem" v-for="(item,index) in item.imgList" :key="index">
                  <img :src="item" :onerror="defaultImg" alt="">
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="addHomeBom" >
      <van-button type="primary" color="#3B87F5" @click="showModel=true">预约</van-button>
    </div>
    <div class="editBtn" @click="changeToEdit"><img src="../assets/editBtn.png" alt=""></div>
    <div class="scanBtn" @click="scanFunc"><img src="../assets/scanBtn.png" alt=""></div>

    <van-popup v-model="showModel" closeable round position="bottom">
      <div class="modelBox">
        <div class="modelTil">预约就餐</div>
        <div class="bomBox">
          <van-tabs type="card" color="#3B87F5" v-model="activeName">
            <van-tab title="一人就餐" name="一人就餐">
              <van-cell-group>
                <van-field v-model="unitDep" readonly label="单位部门" placeholder=""/>
                <van-field v-model="selectDate" is-link readonly label="预约时间" placeholder="请选择预约时间" @click="dateShow = true"/>
                <van-field v-model="eatName" label="预定人名称" placeholder="请输入预定人姓名" />
                <van-field v-model="eatPhone" type="tel" label="电话" placeholder="请输入联系电话" />
              </van-cell-group>
            </van-tab>
            <van-tab title="多人就餐" name="多人就餐">
              <van-cell-group>
                <van-field v-model="eatNum" type="digit" label="就餐人数" placeholder="请输入就餐人数" />
                <van-field v-model="unitDep" readonly label="单位部门" placeholder=""/>
                <van-field v-model="selectDate" is-link readonly label="预约时间" placeholder="请选择预约时间" @click="dateShow = true"/>
                <van-field v-model="eatName" readonly label="预定人名称" placeholder="请输入预定人姓名" />
                <van-field v-model="eatPhone" type="tel" label="电话" placeholder="请输入联系电话" />
              </van-cell-group>
            </van-tab>
          </van-tabs>
        </div>
      </div>
      <div class="bomBtn">
        <div class="leftBtn" @click="showModel = false">取消</div>
        <div class="rightBtn" @click="subscribeFood">确认</div>
      </div>
    </van-popup>
    <van-popup v-model="dateShow" round position="bottom">
      <van-datetime-picker
      v-model="currentDate"
      type="datetime"
      title="选择完整时间"
      :min-date="minDate"
      :max-date="maxDate"
      visible-item-count="5"
      @cancel="dateShow = false" 
      @confirm="confirmDate"
    />
    </van-popup>
    <van-popup v-model="showFalse" round closeable>
      <div class="falseCont">
        <div class="fTopImg"><img src="../assets/scanFalse.png" alt=""></div>
        <div class="fTil">扫码失败</div>
        <div class="fText">{{falseCont}}</div>
      </div>
    </van-popup>
    <van-popup v-model="showTrue" round closeable>
      <div class="trueCont">
        <div class="tTil">确认支付</div>
        <div class="tCenter">
          <span class="price">{{scanAllText.mealFee}}</span>
          <!-- 2022.8.22 晚六点修改 -->
          <!-- <span class="price" v-if="scanAllText.canteenType=='食堂'">-15</span>
          <span class="price" v-if="scanAllText.canteenType=='廉政灶'">-30</span> -->
          元就餐费</div>
        <div class="tUser"><span class="tname" v-if="scanAllText&&scanAllText.workerName">{{scanAllText.workerName}}</span>在<span class="tdate" v-if="nowDate">{{nowDate}}</span></div>
        <div class="tBom">即将支付<span class="taddress" v-if="scanAllText&&scanAllText.canteenName">{{scanAllText.canteenName}}</span></div>
        <van-cell v-if="scanAllText&&scanAllText.businessUnitList.length>1" value-class="van-ellipsis" title="出差单位：" is-link :value="companyText" @click="showCompanuBox" />
        <div class="tBomBtnBox">
          <div class="tBtnLeft" @click="showTrue=false">撤回</div>
          <div class="tBtnRight" @click="getScanText2">确定</div>
        </div>
      </div>
    </van-popup>
    <van-action-sheet v-model="showNav" :actions="actions" @select="onSelectNav" :close-on-click-overlay="false" cancel-text="取消"/>

    <van-popup v-model="showCompanu" round position="bottom">
      <van-picker
        show-toolbar
        :columns="companycolumns"
        @cancel="showCompanu = false"
        @confirm="onConfirmCompany"
      />
    </van-popup>
  </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';
import { Lazyload } from 'vant';
import { Popup } from 'vant';
import { Tab, Tabs } from 'vant';
import { Field } from 'vant';
import { DatetimePicker } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(DatetimePicker);
Vue.use(Field);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Popup);
Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
import { addBaseAplus } from '../utils/zzdmd.js'
export default {
  name: 'canteenDetail',
  data () {
    return {
      // images: [
      //   'https://img01.yzcdn.cn/vant/apple-1.jpg',
      //   'https://img01.yzcdn.cn/vant/apple-2.jpg',
      // ],
      id:this.$route.query.id,
      canteenDetil:'',
      address:sessionStorage.getItem('userAddress')||'定位失败',
      showModel:false,
      value:'',
      minDate: new Date(),
      maxDate: new Date(new Date().getFullYear()-0+3, 1, 1),
      currentDate: new Date(),
      dateShow:false,
      eatNum:'',
      eatName:'',
      eatPhone:'',
      selectDate:'',
      unitDep:'',
      UnitsID:'',
      activeName:'一人就餐',
      actions: [{ name: '高德地图' }],
      showNav:false,
      tlon:0,
      tlat:0,
      taddress:'',
      lon:sessionStorage.getItem('userLon'),
      lat:sessionStorage.getItem('userLat'),
      address:sessionStorage.getItem('userAddress'),
      showFalse:false,
      falseCont:'',
      showTrue:false,
      scanAllText:'',
      nowDate:'',
      scanText:'',
      showCompanu:false,
      companycolumns: [],
      companyId:0,
      companyText:'请选择',
      timers:false
    }
  },
  created(){
    this.id=this.$route.query.id
    this.getCanteenDetail()
    this.selectDate = this.getnow()
    this.nowDate = this.getnow()
    this.getUserInfo()
  },
  mounted(){
    addBaseAplus(this.$route)
  },
  activated(){
    this.id=this.$route.query.id
    this.getCanteenDetail()
    this.selectDate = this.getnow()
    this.nowDate = this.getnow()
  },
  methods:{
    showCompanuBox(){
      this.companycolumns = []
      if(this.scanAllText&&this.scanAllText.businessUnitList.length>1){
        this.scanAllText.businessUnitList.map((item,index)=>{
          this.companycolumns.push({
            text:item.olName,
            value:item.id
          })
        })
      }
      this.showCompanu = true
    },
    onConfirmCompany(e){
      this.companyId = e.value
      this.companyText = e.text
      this.showCompanu = false
    },
    getCanteenDetail(){
      let param = {
        CanteenID:this.id,
        WorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        // WorkerID:78860337
      }
       this.$post('api/Canteen/GetCanteenEntity', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          res.data.cEntity.cByPicture = res.data.cEntity.cByPicture.split(',')
          res.data.eList.map((item)=>{
            if(item.ePicture){
              item.imgList = item.ePicture.split(',')
            }
          })
          this.canteenDetil = res.data
        }
      })
    },

    
    collection(){
      let param = {
        wcWorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        // wcWorkerID:11,
        wcCanteenID:this.id
      }
       this.$post('api/User/InsertCollection', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          Toast({
          message: '收藏成功',
          position: 'bottom',
          })
          this.getCanteenDetail()
        }
      })
    },
    collection1(){
      let param = {
        WorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        CanteenID:this.id,
        // WorkerID:11
      }
       this.$post('api/User/DeleteCollection', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          Toast({
          message: '取消成功',
          position: 'bottom',
          })
          this.getCanteenDetail()
        }
      })
    },
    getUserInfo(){
      let param = {
        WorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID
        // WorkerID:11
      }
       this.$post('api/User/GetUserUnitsAndName', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.eatName = res.data.name
          this.unitDep = res.data.unitsName
          this.UnitsID = res.data.unitsID
        }
      })
    },
    isPoneAvailable(phone) {
        let myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!myreg.test(phone)) {
            return false
        } else {
            return true
        }
    },
    subscribeFood(){
      
      let num = 1
      if(this.activeName=='多人就餐'){
        num = this.eatNum
        if(!(this.eatNum-0)){
          Toast({
          message: '用餐人数不正确',
          position: 'bottom',
          })
          return
        }
      }
      if(this.eatPhone == ''){
            Toast({
            message: '请输入手机号',
            position: 'bottom',
            })
            return
        }
        if(!this.isPoneAvailable(this.eatPhone)){
            Toast({
            message: '请输入正确的手机号',
            position: 'bottom',
            })
            return
        }
        dd.showLoading({
          text: "", //提示信息
        })
      let param = {
        boWorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        // boWorkerID:'11',
        boAppointment:this.selectDate,
        boBookingPerson:this.eatName,
        boDiningType:this.activeName,
        boNumber:num,
        boPhone:this.eatPhone,
        boUnitsID:this.UnitsID,
        boCanteenID:this.id,

      }
       this.$post('api/Canteen/SubscribeFood', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        dd.hideLoading({})
        if(res.code==1000){
          this.dateShow = false
          this.showModel = false
          Toast({
          message: '预约成功',
          position: 'bottom',
          })
        }else{
          Toast({
          message: res.msg||res.message,
          position: 'bottom',
          })
        }
      })
    },
    confirmDate(e){
      this.selectDate = this.getnow(e)
      this.dateShow = false
    },
    getnow(dates){
      var mynow = dates?new Date(dates):new Date();//默认的获取的是当前时间
      //通过调用日期对象的方法来重新获取当前的日期时间
      //mynow.setFullYear(2016);
      var year = mynow.getFullYear();//获取年
      var month = (mynow.getMonth()+1)<10?'0'+(mynow.getMonth()+1):(mynow.getMonth()+1);//获取月
      var day = mynow.getDate()<10?'0'+mynow.getDate():mynow.getDate();//获取日
      var hour =mynow.getHours()<10?'0'+mynow.getHours():mynow.getHours();//获取小时
      var minute =mynow.getMinutes()<10?'0'+mynow.getMinutes():mynow.getMinutes();//获取分钟
      // var second =mynow.getSeconds();//获取秒
      var strdate = year+'-'+ month+"-"+day+' '+hour+':'+minute
      return strdate
    },
    getUrlKey1: function (name,url) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    scanFunc(){
      let _this = this;
      this.$post("api/Dingding/GetJSAPOTicket").then((res) => {
          if ( res.code == 1000) {
            let ticket = res.data.content.data.accessToken;
            //01 获取鉴权码
            // 02  鉴权
            dd.authConfig({
              ticket: ticket,
              jsApiList: ["scan"],
            }).then((res) => {
                // 03 判断鉴权结果后，使用获取地理位置
                dd.scan({
                  type:'qr'
                }).then((res) => {
                  this.getScanText(this.getUrlKey1('qrcode',res.text))
                })
              }).catch((err) => {
                Dialog.alert({
                  title: '提示',
                  message: '打开扫码失败',
                }).then(() => {
                  // on close
                });
              });
          }
        }).catch((err) => {
          Dialog.alert({
            title: '提示',
            message: '打开扫码失败',
          }).then(() => {
            // on close
          });
        });
    },
    getScanText(text){
      this.scanText = text
      let param = {
        QRCode:text,
        WorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        // WorkerID:102061,
        Probe:false
      }
      this.$post('api/Canteen/Estimate', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.scanAllText = res.data
          if(res.data.businessUnitList.length==1){
            this.companyId = res.data.businessUnitList[0].id
          }
          this.showTrue = true
        }else{
          this.falseCont = res.msg||res.message
          this.showFalse = true
        }
      })
    },
    getScanText2(){
      if(this.timers){
        setTimeout(()=>{
          this.timers = false
        },1000)
        return
      }
      this.timers = true
      if(this.scanAllText&&this.scanAllText.businessUnitList.length>1){
        if(!this.companyId){
          Toast({
            message: '请先选择出差单位',
            position: 'bottom',
          })
          return
        }
      }
      this.showTrue = false
      let param = {
        QRCode:this.scanText,
        WorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        // WorkerID:102061,
        Probe:true,
        Longitude:sessionStorage.getItem('userLon'),
        Latitude:sessionStorage.getItem('userLat'),
        BusinessUnit:this.companyId||0
      }
      this.$post('api/Canteen/Estimate', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.$router.push({path:'/scanSucess',query:{oid:res.data.orderID,cid:res.data.canteenID,mealFee:res.data.mealFee}})
        }else{
          this.falseCont = res.msg||res.message
          this.showFalse = true
        }
      })
    },
    changeToEdit(){
      this.$router.push({path:'/comment',query:{id:this.id,oid:0}})
    },
    getCall(phone){
      if(!phone){
        return
      }
      dd.callPhone({
          phoneNum: phone,//电话号码
      }).then(res => {
          console.log(res)
      }).catch(err => {})
    },
    changeToNav(tlon,tlat,taddress){
      if(!taddress){
        return
      }
      this.tlon = tlon
      this.tlat = tlat
      this.taddress = taddress
      this.showNav = true
    },
    onSelectNav(item){
      if(item.name=='百度地图'){
        // dd.openLink({
        //     url: `http://api.map.baidu.com/direction?origin=latlng:${this.lat},${this.lon}|name:${this.address}&destination=latlng:${this.tlat},${this.tlon}|name:${this.taddress}&mode=driving&coord_type=gcj02&src=webapp.baidu.openAPIdemo`
        // }).then(res => {
        //     console.log(res)
        // }).catch(err => {})
      }else if(item.name=='高德地图'){
        dd.openLink({
            url: `https://uri.amap.com/navigation?from=${this.lon},${this.lat},${this.address}&to=${this.tlon},${this.tlat},${this.taddress}&coordinate=gaode&callnative=1`
        }).then(res => {
            console.log(res)
        }).catch(err => {})
      }
      this.showNav = false
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  background: #f2f2f2;
  min-height: 100vh;
  position: relative;
}
.mainTop{
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 12px;
}
.topLocation{
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  padding: 10px 0;
  display: flex;
  align-items: center;
  z-index: 1;
  background: #fff;
}
.topLocationImg{
  width: 13px;
  height: 16px;
}
.topLocationImg>img{
  width: 100%;
  height: 100%;
}
.topLocationTil{
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  max-width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 10px;
}
.swiperBox{
  width:100%;
  height: 150px;
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 12px;
  background: #fff;
}

div /deep/ .van-swipe-item>img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.canteenDetail{
  box-sizing: border-box;
  padding: 15px 13px 0;
  background: #fff;
}
.cantTil{
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.rightCenterLeft{
  margin: 10px 0;
  display: flex;
  align-items: center;
}
.starList{
  display: flex;
  align-items: center;
  margin-right: 15px;
}
.starBox{
  display: flex;
  align-items: center;
}
.starBox>img{
  width: 12px;
  height: 12px;
  margin-right: 6px;
}
.score{
  font-size: 12px;
  font-weight: 800;
  color: #FF9023;
}
.bomLine{
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.bomLineLeft{
  color: #999999;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
.bomLineRight{
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  margin-left: 6px;
  line-height: 18px;
  max-width: 76%;
}
.textBox{
  box-sizing: border-box;
  padding: 13px 0 15px;
  border-top: 1px solid #E6E6E6;
}
.text{
  text-indent: 2em;
  font-size: 12px;
  color: #333333;
  line-height: 18px;
}
.addHomeBom{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 54px;
    box-sizing: border-box;
    padding: 0 18px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    /* background-color: #fff;
    border-top: 1px solid #ebedf0; */
}
.van-button{
    padding: 0 105px;
    width: 100%;
    height: 36px;
    border-radius: 18px;
    white-space: nowrap;
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}
.bomCont{
  width: 100%;
  box-sizing: border-box;
  padding: 15px 13px 74px;
  background: #fff;
}
.bomContTil{
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.commentList{
  box-sizing: border-box;
  padding-top: 10px;
}
.commentList>ul>li{
  box-sizing: border-box;
  padding: 10px 0;
  border-bottom: 1px solid #E6E6E6;
}
.commentList>ul>li:last-child{
  border-bottom: none;
}
.itemTop{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.itemTopLeft{
  display: flex;
  align-items: center;
}
.itemTopLeftL{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
}
.itemTopLeftL>img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.itemTopLeftRtop{
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.itemTopLeftRbom{
  margin-top: 10px;
}
.itemTopRight{
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}

.itemText{
  font-size: 14px;
  font-weight: 500;
  color: #666666;
  line-height: 18px;
  margin: 10px 0;
}
.itemBom{
  width: 100%;
}
.imglist{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.imgItem{
  width: 109px;
  height: 109px;
  border-radius: 5px;
  overflow: hidden;
  margin-right: 10px;
  margin-bottom: 10px;
}
.imgItem:nth-child(3n){
  margin-right: 0;
}
.imgItem>img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.editBtn{
  width: 48px;
  height: 48px;
  position: fixed;
  top: 108px;
  right: 8px;
  z-index: 1;
}
.editBtn>img{
  width: 100%;
  height: 100%;
}
.scanBtn{
  width: 58px;
  height: 58px;
  position: fixed;
  bottom: 72px;
  right: 8px;
  z-index: 1;
}
.scanBtn>img{
  width: 100%;
  height: 100%;
}

.modelBox{
  width: 100%;
  box-sizing: border-box;
  padding: 15px 12px 0;
}
.modelTil{
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  text-align: center;
}
.bomBox{
  margin-top: 15px;
}
.bomBtn{
  margin-top: 20px;
  display: flex;
  align-items: center;
  border-top: 1px solid #ddd;
}
.leftBtn{
  width: 50%;
  height: 49px;
  text-align: center;
  line-height: 49px;
  background-color: #fff;
  font-size: 16px;
  font-weight: 500;
  color: #666666 ;
}
.rightBtn{
  width: 50%;
  height: 49px;
  text-align: center;
  line-height: 49px;
  background-color: #3B87F5;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.falseCont{
  box-sizing: border-box;
  padding: 50px 42px;
  background-color: #fff;
  border-radius: 5px;
  width: 80vw;
  text-align: center;
}
.fTopImg{
  width: 44px;
  height: 44px;
  margin: 0 auto;
}
.fTopImg>img{
  width: 100%;
  height: 100%;
}
.fTil{
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin-top: 15px;
}
.fText{
  font-size: 12px;
  font-weight: 500;
  color: #666666;
  margin-top: 10px;
}
.trueCont{
  box-sizing: border-box;
  padding: 12px 28px;
  background-color: #fff;
  border-radius: 5px;
  width: 80vw;
  text-align: center;
}
.tTil{
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.tCenter{
  margin-top: 24px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}
.price{
  font-size: 28px !important;
  color: #EA6363 !important;
}
.tUser{
  margin-top:12px;
  font-size: 14px;
  color:#333333;
}
.tdate{
  color:#3B87F5 !important;
}
.tBom{
  margin-top:4px;
  font-size: 14px;
  color:#333333;
}
.tBomBtnBox{
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 15px;
}
.tBtnLeft{
  padding:5px 22px;
  border-radius: 4px;
  border: 1px solid #3B87F5;
  font-size: 16px;
  color: #3B87F5;
}
.tBtnRight{
  padding:5px 22px;
  border-radius: 4px;
  font-size: 16px;
  color: #fff;
  background: #3B87F5;
}
.infoTop{
  display:flex;
  justify-content: space-between;
}
.infoTf{
  max-width:80%;
}
.infoTr{
  text-align: center;
  margin-top: 5px;
}
.collectionIcon{
  width: 16px;
  height: 14px;
  margin: 0 auto;
}
.collectionIcon>img{
  width: 100%;
  height: 100%;
}
.collectionText{
  font-size: 12px;
  font-weight: 500;
  color: #333333;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/page/canteenDetail.vue